import React from 'react';
import { useTranslation } from 'react-i18next';
import FadeInSection from './FadeInSection';

const PhilosophySection: React.FC = () => {
  const { t } = useTranslation('website');

  return (
    <section id="philosophy" className="py-24 lg:py-32 relative section-alt overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background */}
          <div className="absolute inset-0">
            <img
              src="/images/philosophy.png"
              alt="Philosophy"
              className="w-full h-full object-cover"
              onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-dark-950/95 via-dark-950/80 to-dark-950/50" />
          </div>

          {/* Content */}
          <div className="relative z-10 p-10 sm:p-14 lg:p-20">
            <div className="max-w-xl">
              <FadeInSection>
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-8 h-[2px] bg-accent-500" />
                  <span className="text-accent-400 text-xs font-semibold tracking-wider uppercase">{t('philosophy.label')}</span>
                </div>
                <h2 className="text-3xl lg:text-4xl font-extrabold text-white mb-6 leading-snug">
                  {t('philosophy.title')}<br />{t('philosophy.titleAccent')}
                </h2>
                <p className="text-dark-300 mb-5" style={{ lineHeight: '1.9' }}>{t('philosophy.p1')}</p>
                <p className="text-dark-400 mb-10" style={{ lineHeight: '1.9' }}>{t('philosophy.p2')}</p>
              </FadeInSection>

              <div className="flex flex-col sm:flex-row gap-6">
                <FadeInSection delay="fade-in-delay-1" className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-accent-500/15 border border-accent-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i data-lucide="handshake" className="text-accent-400" />
                  </div>
                  <div>
                    <div className="text-white font-semibold text-sm mb-1">{t('philosophy.value1Title')}</div>
                    <div className="text-dark-400 text-xs">{t('philosophy.value1Desc')}</div>
                  </div>
                </FadeInSection>

                <FadeInSection delay="fade-in-delay-2" className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-accent-500/15 border border-accent-500/20 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i data-lucide="trending-up" className="text-accent-400" />
                  </div>
                  <div>
                    <div className="text-white font-semibold text-sm mb-1">{t('philosophy.value2Title')}</div>
                    <div className="text-dark-400 text-xs">{t('philosophy.value2Desc')}</div>
                  </div>
                </FadeInSection>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;
